import { render } from "./TransactionDetailAssetItem.vue?vue&type=template&id=65155a14"
import script from "./TransactionDetailAssetItem.vue?vue&type=script&lang=js"
export * from "./TransactionDetailAssetItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue-project\\asset-labuhan-digital\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QAvatar,QItemLabel,QBadge,QIcon,QBtn,QDialog,QCard,QForm,QCardSection,QCheckbox,QBtnToggle,QCardActions});qInstall(script, 'directives', {ClosePopup});
